"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCollapseTitle = exports.StyledCollapseHeader = exports.StyledArrowIconWrapper = exports.StyledCollapseContent = exports.StyledCollapse = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const buttonReset_styles_1 = require("../DesignSystem/styles/buttonReset.styles");
const helpers_1 = require("../helpers");
exports.StyledCollapse = styled_components_1.default.div ``;
exports.StyledCollapseContent = styled_components_1.default.div `
    padding: ${helpers_1.SPACING_S};
    font: ${helpers_1.BASE_FONT};
`;
exports.StyledArrowIconWrapper = styled_components_1.default.div `
    display: flex;
    justify-items: center;
    align-items: center;
    height: ${helpers_1.FONT_LINE_HEIGHT_M};
    margin-right: ${helpers_1.SPACING_S};
`;
exports.StyledCollapseHeader = styled_components_1.default.button `
    ${buttonReset_styles_1.buttonReset};
    display: flex;
    align-items: flex-start;
    width: 100%;
    padding: ${helpers_1.SPACING_S};
    background-color: ${({ theme }) => theme.colorBackgroundDisabled};
    cursor: pointer;
`;
exports.StyledCollapseTitle = styled_components_1.default.div `
    font-family: ${helpers_1.BASE_FONT_FAMILY};
    font-size: ${helpers_1.FONT_SIZE_M};
    line-height: ${helpers_1.FONT_LINE_HEIGHT_M};
    font-weight: ${helpers_1.BASE_FONT_SEMI_BOLD_WEIGHT};
    color: ${({ theme }) => theme.colorTextMain};
`;
//# sourceMappingURL=Collapse.styles.js.map